import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

import { AboutFormData } from '../../types';
import { EnumRadioGroup } from '../../heating/components/enumRadioGroup';
import { EnumRadioButton } from '../../heating/components/enumRadioButton';
import { JaNeiVetIkke } from '../../../../../utils/registerEnums';

interface HeatedBasementRadiogroupProps {
  control: Control<AboutFormData>;
}

export const HeatedBasementRadiogroup: FC<HeatedBasementRadiogroupProps> = ({ control }) => {
  return (
    <Controller
      name="bygginfo.isHeatedBasement"
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        // Need to set empty selection to radio. Passing value directly will
        // set option to "Nei" when value is undefined.
        const enumValue = value === true ? JaNeiVetIkke.Ja : value === false ? JaNeiVetIkke.Nei : undefined;

        return (
          <EnumRadioGroup
            labelKey="register.bygningsdetaljer.harBoligenKjeller.yes.label"
            helperTextKey="register.bygningsdetaljer.harBoligenKjeller.yes.information"
            onChange={(value) => onChange(value === JaNeiVetIkke.Ja)}
            value={enumValue}
            error={error}
          >
            <EnumRadioButton value={JaNeiVetIkke.Ja} i18nPrefix="register" />
            <EnumRadioButton value={JaNeiVetIkke.Nei} i18nPrefix="register" />
          </EnumRadioGroup>
        );
      }}
    />
  );
};
